import gql from "graphql-tag";
const publishMessage =  gql(`
mutation ($message: MessageInput) {
  publishMessage(message: $message) {
    id
    message
    error
  }
}
`);
export default publishMessage;
